export enum LinkedDocsTypes {
    /// <summary>
    /// Удалить ссылку (исключить)
    /// </summary>
    RemoveLink,
}
